import { ChevronDownIcon } from '@sketchnote/icons';
import { ProfileImageIcon } from '@sketchnote/icons';
import React from 'react';
import Select, { components, OptionProps, OptionsType, OptionTypeBase } from 'react-select';
import { Styles } from 'react-select';

import { Avatar } from '../avatar';

export const SelectStyleSearch: Styles<any, false> = {
  control: (styles) => ({
    ...styles,
    backgroundColor: '#F6F7F9',
    paddingTop: '6px',
    paddingBottom: '6px',
    paddingLeft: '0px',
    paddingRight: '12px',
    borderRadius: '6px',
    borderColor: '#E2E4E9',
    fontWeight: 400,
    fontSize: '1.6rem',
    color: '#131720',
    width: '32.4rem',
  }),
  menu: (styles) => ({
    ...styles,
    padding: '8px',
    borderRadius: '6px',
    width: '33.2rem',
  }),
  groupHeading: (styles) => ({
    ...styles,
    fontWeight: 500,
    color: '#878A92',
    fontSize: '12px',
    paddingTop: '6px',
    paddingBottom: '6px',
    paddingLeft: '4px',
    paddingRight: '6px',
  }),
  option: (styles, { isDisabled, isFocused, isSelected }) => {
    return {
      ...styles,
      backgroundColor: isDisabled
        ? '#F6F7F9'
        : isSelected
        ? '#F6F7F9'
        : isFocused
        ? '#F6F7F9'
        : 'inherit',
      paddingTop: '6px',
      paddingBottom: '6px',
      paddingLeft: '4px',
      paddingRight: '6px',
      fontWeight: 400,
      fontSize: '14px',
      lineHeight: '20px',
      color: isDisabled ? '#ccc' : '#131720',
      cursor: isDisabled ? 'not-allowed' : 'default',
      borderRadius: '6px',
      ':active': {
        ...styles[':active'],
        backgroundColor: '#EEF1FC',
      },
    };
  },
};
export type OptionSearch = { label: string; value: string; memberId: string; avatar: string };
const DropdownIndicator = () => {
  return <ChevronDownIcon wrapperClass="text-gray-500" />;
};

const { Option } = components;
const OptionDisplay = (props: any) => (
  <Option {...props}>
    <div className="flex">
      <Avatar src={props.data.avatar} name={props.data.label} size="sm" wrapperClassName="border" />
      &nbsp;&nbsp; {props.data.label}
    </div>
  </Option>
);

const SingleValueSearch = (props: any) => (
  <components.SingleValue {...props}>
    <div className="flex">
      <Avatar src={props.data.avatar} name={props.data.label} size="sm" wrapperClassName="border" />
      &nbsp;&nbsp; {props.data.label}
    </div>
  </components.SingleValue>
);
export interface UserSearchProps {
  placeholder?: JSX.Element;
  options: OptionSearch[];
  onChange?: (prop: OptionSearch) => void;
  disabled?: boolean;
  label?: string;
  className?: string;
  isMulti?: boolean;
  required?: boolean;
  value?: OptionSearch;
  id?: string;
}
export const UserSearch = ({
  placeholder,
  options,
  onChange,
  disabled,
  value,
  className,
  id,
  ...otherProps
}: UserSearchProps): JSX.Element => {
  return (
    <Select
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      options={options}
      styles={SelectStyleSearch}
      className={className}
      isDisabled={disabled}
      isLoading={false}
      isClearable={false}
      isRtl={false}
      id={id}
      isSearchable={true}
      components={{
        DropdownIndicator: DropdownIndicator,
        Option: OptionDisplay,
        SingleValue: SingleValueSearch,
        IndicatorSeparator: () => null,
      }}
      {...otherProps}
    />
  );
};
